import { render, staticRenderFns } from "./SelectSupplier.vue?vue&type=template&id=024b01f8&scoped=true"
import script from "./SelectSupplier.vue?vue&type=script&lang=js"
export * from "./SelectSupplier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024b01f8",
  null
  
)

export default component.exports